import {
  buildListParams,
  getListData,
  getTotalRecords,
  handleListDeleteIconMouseEnter,
  handleListIconMouseEnter,
  handleListIconMouseLeave,
  listStyles,
  loadStoredJson,
  removeStoredKeys,
  saveStoredValue
} from 'lib/listUtils';
import {
  Box,
  Button,
  Card,
  CardContent,
  Input,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip
} from '@material-ui/core';
import {
  BackspaceOutlined,
  DeleteForeverOutlined,
  EditTwoTone,
  Search,
  VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { getResponseData } from 'lib/formUtils';
import { ComboPadraoMultiple } from 'views/Components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { ANAO, APESSOA_FISICA, APESSOA_JURIDICA, ASIM } from 'consts';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class ClienteList extends Component {
  state = {
    searchFilter: loadStoredJson('clienteSearchFilter', {
      cliente: '',
      fantasia: '',
      codcliente: '',
      cnpjcpf: '',
      desccidade: '',
      logradouro: '',
      tipopessoaFilter: APESSOA_JURIDICA,
      situacaoInativoFilter: ANAO,
      categorias: []
    }),
    clientes: [],
    listaCategorias: [],
    open: false,
    openAlert: false,
    messageAlert: '',
    selectedId: null,
    selectedDesc: null,
    totalItems: 0,
    page: Number(sessionStorage.getItem('clientePage')) || 0,
    rowsPerPage: Number(sessionStorage.getItem('clienteRowsPerPage')) || 10
  };

  estilo = listStyles;

  _isMounted = false;

  handleIconMouseEnter = handleListIconMouseEnter;
  handleIconMouseLeave = handleListIconMouseLeave;
  handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
  safeSetState = safeSetState;

  /* Carrega os dados iniciais da tela */
  async componentDidMount() {
    this._isMounted = true;

    await this.loadCategoriasFiltro();

    this.loadClientes();
  };

  /* Paginação */
  componentDidUpdate(prevProps, prevState) {
    const { page, rowsPerPage, searchFilter } = this.state;

    // persiste os filtros e a paginação no sessionStorage
    if (prevState.searchFilter !== searchFilter) {
      saveStoredValue('clienteSearchFilter', searchFilter);
    }

    if (prevState.page !== page) {
      saveStoredValue('clientePage', page);
    }

    if (prevState.rowsPerPage !== rowsPerPage) {
      saveStoredValue('clienteRowsPerPage', rowsPerPage);
    }
  };

  /* Limpa os filtros e a paginação ao sair da tela */
  componentWillUnmount() {
    this._isMounted = false;

    removeStoredKeys([
      'clienteSearchFilter',
      'clientePage',
      'clienteRowsPerPage'
    ]);
  };

  /* Carrega as categorias de cliente pro filtro */
  loadCategoriasFiltro = async () => {
    try {
      const response = await api.get('/tipocliente');
      const categorias = getResponseData(response);

      const listaCategorias = categorias.map(categoria => ({
        id: categoria.codtipocliente,
        item: categoria.desctipocliente
      }));

      this.safeSetState({ listaCategorias });
    } catch (error) {
      console.error('Erro ao carregar as categorias de cliente:', error);
    }
  };

  /* Carrega os clientes */
  loadClientes = async () => {
    const { searchFilter, page, rowsPerPage } = this.state;

    const {
      categorias,
      cliente,
      cnpjcpf,
      codcliente,
      desccidade,
      fantasia,
      logradouro,
      situacaoInativoFilter,
      tipopessoaFilter
    } = searchFilter;

    const filtros = [
      {
        field: 'CLIENTE',
        value: cliente,
        operator: '_like_'
      },
      {
        field: 'FANTASIA',
        value: fantasia,
        operator: '_like_'
      },
      {
        field: 'CODCLIENTE',
        value: codcliente
      },
      {
        field: 'CNPJCPF',
        value: cnpjcpf,
        operator: '_like_'
      },
      {
        field: 'DESCCIDADE',
        value: desccidade,
        operator: '_like_'
      },
      {
        field: 'LOGRADOURO',
        value: logradouro,
        operator: '_like_'
      },
      {
        field: 'INATIVO',
        value: situacaoInativoFilter
      }
    ];

    if (tipopessoaFilter && tipopessoaFilter !== 'T') {
      filtros.push({
        field: 'TIPOPESSOA',
        value: tipopessoaFilter
      });
    }

    if (categorias && categorias.length > 0) {
      const codigoCategorias = categorias.map(c => c.id);

      filtros.push({
        field: 'CODTIPOCLIENTE',
        value: codigoCategorias.join(','),
        operator: '_in_'
      });
    }

    const params = buildListParams({
      page,
      rowsPerPage,
      filters: filtros
    });

    try {
      const response = await api.get('/cliente' + params);

      this.safeSetState({
        clientes: getListData(response),
        totalItems: getTotalRecords(response)
      });
    } catch (error) {
      console.error('Erro ao carregar os clientes:', error);

      this.safeSetState({
        clientes: [],
        totalItems: 0
      });
    }
  };

  /* Muda a página */
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.loadClientes);
  };

  /* Muda a quantidade de retornos por página */
  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    }, this.loadClientes);
  };

  /* Deleta o cliente */
  handleDelete = async (id) => {
    try {
      const response = await api.delete(`/cliente/${id}`);

      // verifica se a exclusão foi bem-sucedida
      if (response.status === 200) {
        this.handleClose();
        this.loadClientes();
      }
    } catch (error) {
      this.handleClose();

      this.handleOpenAlert(
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Erro ao excluir cliente!'
      );
    }
  };

  /* Confirma a exclusão */
  handleConfirmDelete = () => {
    const { selectedId } = this.state;

    this.handleDelete(selectedId);
  };

  /* Abre a janela de confirmação para a exclusão */
  handleOpen = (codcliente, cliente) => {
    this.setState({
      open: true,
      selectedId: codcliente,
      selectedDesc: cliente
    });
  };

  /* Abre a janela de alerta com mensagem */
  handleOpenAlert = (message) => {
    this.setState({
      openAlert: true,
      messageAlert: message
    });
  };

  /* Fecha a janela de confirmação da exclusão */
  handleClose = () => {
    this.setState({
      open: false,
      selectedId: null,
      selectedDesc: ''
    });
  };

  /* Fecha a janela de mensagem alerta */
  handleCloseAlert = () => {
    this.setState({ openAlert: false });
  };

  /* Pesquisa os filtros na tela */
  onChangeSearch = (event) => {
    const { name, value } = event.target;

    const searchFilter = {
      ...this.state.searchFilter,
      [name]: (typeof value === 'string') ? value.toUpperCase() : value
    };

    this.setState({
      searchFilter,
      page: 0
    });
  };

  /* Pesquisa as categorias de cliente */
  onChangeCategorias = (selected) => {
    this.setState({
      searchFilter: {
        ...this.state.searchFilter,
        categorias: selected
      },
      page: 0
    });
  };

  /* Limpa os filtros da tela */
  limpaFiltros = () => {
    const searchFilter = {
      cliente: '',
      fantasia: '',
      codcliente: '',
      cnpjcpf: '',
      desccidade: '',
      logradouro: '',
      tipopessoaFilter: APESSOA_JURIDICA,
      situacaoInativoFilter: ANAO,
      categorias: []
    };

    this.setState({
      searchFilter,
      page: 0
    }, this.loadClientes);
  };

  render() {
    const {
      clientes,
      listaCategorias,
      messageAlert,
      open,
      openAlert,
      page,
      rowsPerPage,
      searchFilter,
      selectedDesc,
      selectedId,
      totalItems
    } = this.state;

    const {
      actionIcon,
      addButton,
      filterPaper,
      iconGroup,
      redText
    } = this.estilo;

    const basePath = this.props.match?.url || '';

    return (
      <div style={this.estilo}>
        <Paper
          style={{
            ...filterPaper,
            width: '100%'
          }}
        >
          <Input
            autoFocus
            id="cliente"
            name="cliente"
            onChange={this.onChangeSearch}
            placeholder="Nome / Razão social"
            value={searchFilter.cliente}
            style={{
              flex: '0 1 220px',
              minWidth: 220
            }}
          />

          <Input
            id="fantasia"
            name="fantasia"
            onChange={this.onChangeSearch}
            placeholder="Nome fantasia"
            value={searchFilter.fantasia}
            style={{
              flex: '0 1 220px',
              minWidth: 220
            }}
          />

          <Box
            style={{
              flex: '0 1 220px',
              minWidth: 220,
              marginBottom: 16
            }}
          >
            <ComboPadraoMultiple
              options={searchFilter.categorias || []}
              label="Categorias"
              itens={listaCategorias}
              onSelectionChange={this.onChangeCategorias}
            />
          </Box>

          <Select
            id="situacaoInativoFilter"
            name="situacaoInativoFilter"
            value={searchFilter.situacaoInativoFilter || ''}
            onChange={this.onChangeSearch}
            style={{
              flex: '0 1 100px',
              minWidth: 100,
              textAlign: 'center'
            }}
          >
            <MenuItem
              value={ANAO}
              style={{ justifyContent: 'center' }}
            >
              Ativos
            </MenuItem>

            <MenuItem
              value={ASIM}
              style={{ justifyContent: 'center' }}
            >
              Inativos
            </MenuItem>

            <MenuItem
              value={'T'}
              style={{ justifyContent: 'center' }}
            >
              Todos
            </MenuItem>
          </Select>

          <span style={iconGroup}>
            <Tooltip title="Procurar">
              <Search
                onClick={this.loadClientes}
                onMouseEnter={this.handleIconMouseEnter}
                onMouseLeave={this.handleIconMouseLeave}
                style={actionIcon}
              />
            </Tooltip>

            <Tooltip title="Limpar">
              <BackspaceOutlined
                onClick={this.limpaFiltros}
                onMouseEnter={this.handleIconMouseEnter}
                onMouseLeave={this.handleIconMouseLeave}
                style={actionIcon}
              />
            </Tooltip>
          </span>

          <div style={{ flex: 1 }} />

          <Button
            component={Link}
            to={`${basePath}/novo`}
            variant="contained"
            color="primary"
            style={addButton}
          >
            Novo
          </Button>
        </Paper>

        <br />

        <Paper
          style={{
            ...filterPaper,
            width: '100%'
          }}
        >
          <Select
            id="tipopessoaFilter"
            name="tipopessoaFilter"
            value={searchFilter.tipopessoaFilter || APESSOA_JURIDICA}
            onChange={this.onChangeSearch}
            style={{
              flex: '0 1 140px',
              minWidth: 140
            }}
          >
            <MenuItem value={APESSOA_FISICA}>
              Física
            </MenuItem>

            <MenuItem value={APESSOA_JURIDICA}>
              Jurídica
            </MenuItem>

            <MenuItem value={'T'}>
              Todos
            </MenuItem>
          </Select>

          <Input
            id="cnpjcpf"
            name="cnpjcpf"
            onChange={this.onChangeSearch}
            placeholder="CNPJ / CPF"
            value={searchFilter.cnpjcpf}
            style={{
              flex: '0 1 200px',
              minWidth: 200
            }}
          />

          <Input
            id="codcliente"
            name="codcliente"
            onChange={this.onChangeSearch}
            placeholder="Código"
            value={searchFilter.codcliente}
            style={{
              flex: '0 1 140px',
              minWidth: 140
            }}
          />
        </Paper>

        <br />

        <Paper
          style={{
            ...filterPaper,
            width: '100%'
          }}
        >
          <Input
            id="desccidade"
            name="desccidade"
            onChange={this.onChangeSearch}
            placeholder="Cidade"
            value={searchFilter.desccidade}
            style={{
              flex: '0 1 220px',
              minWidth: 220
            }}
          />

          <Input
            id="logradouro"
            name="logradouro"
            onChange={this.onChangeSearch}
            placeholder="Logradouro"
            value={searchFilter.logradouro}
            style={{
              flex: '0 1 220px',
              minWidth: 220
            }}
          />
        </Paper>

        <br />

        <Card>
          <CardContent>
            <PerfectScrollbar>
              <div>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Código</TableCell>

                      <TableCell align="center">Nome / Razão social</TableCell>

                      <TableCell align="center">Nome fantasia</TableCell>

                      <TableCell align="center">Fone</TableCell>

                      <TableCell align="center">Ações</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {clientes.length === 0 && (
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={5}
                        >
                          Nenhum cliente encontrado
                        </TableCell>
                      </TableRow>
                    )}

                    {clientes.map(cliente => (
                      <TableRow
                        hover
                        key={cliente.codcliente}
                      >
                        <TableCell
                          align="center"
                          style={(cliente.inativo === ASIM) ? redText : {}}
                        >
                          {cliente.codcliente}
                        </TableCell>

                        <TableCell
                          align="center"
                          style={(cliente.inativo === ASIM) ? redText : {}}
                        >
                          {cliente.cliente}
                        </TableCell>

                        <TableCell
                          align="center"
                          style={(cliente.inativo === ASIM) ? redText : {}}
                        >
                          {cliente.fantasia}
                        </TableCell>

                        <TableCell
                          align="center"
                          style={(cliente.inativo === ASIM) ? redText : {}}
                        >
                          {cliente.fone}
                        </TableCell>

                        <TableCell align="center">
                          <span style={iconGroup}>
                            <Tooltip title="Editar">
                              <Link to={`${basePath}/${cliente.codcliente}`}>
                                <EditTwoTone
                                  onMouseEnter={this.handleIconMouseEnter}
                                  onMouseLeave={this.handleIconMouseLeave}
                                  style={actionIcon}
                                />
                              </Link>
                            </Tooltip>

                            <Tooltip title="Visualizar">
                              <Link to={`${basePath}/${cliente.codcliente}/view`}>
                                <VisibilityOutlined
                                  onMouseEnter={this.handleIconMouseEnter}
                                  onMouseLeave={this.handleIconMouseLeave}
                                  style={actionIcon}
                                />
                              </Link>
                            </Tooltip>

                            <Tooltip title="Excluir">
                              <DeleteForeverOutlined
                                onClick={() => this.handleOpen(
                                  cliente.codcliente,
                                  cliente.cliente
                                )}
                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                              />
                            </Tooltip>
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </PerfectScrollbar>

            <TablePagination
              component="div"
              count={totalItems}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10, 50, 100, 200]}
              labelRowsPerPage="Registros por página"
            />
          </CardContent>
        </Card>

        <DeleteConfirmationModal
          open={open}
          itemId={selectedId}
          message={`Confirma exclusão do cliente ${selectedDesc || ''} [${selectedId}]?`}
          handleClose={this.handleClose}
          handleDelete={this.handleConfirmDelete}
        />

        <AlertInformation
          open={openAlert}
          message={messageAlert}
          handleClose={this.handleCloseAlert}
        />
      </div>
    );
  }
};

export default ClienteList;